<style scoped lang="less">
</style>

<template>
    <div class="yb-container">
        <div class="line-container">
            <el-button size="mini" type="success" @click.stop="addOrEdit(null)">新增</el-button>
        </div>

        <paged-table ref="table" @fetch-data="fetchData" class="block-mini-top">
            <el-table slot :data="data" border size="mini" row-key="index" border default-expand-all :tree-props="{children: 'children'}" :cell-style="$parent.$parent.cellStyle">
                <el-table-column label="父菜单" align="center" prop="parentMenu" width="140">
                    <template slot-scope="scope">
                        <span v-if="scope.row.childMenu ==''">{{scope.row.parentMenu}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="子菜单" align="center" prop="childMenu" width="140"></el-table-column>
                <el-table-column label="序号" align="center" prop="index" width="50"></el-table-column>
                <el-table-column label="path" align="center" prop="path" width="200"></el-table-column>
                <el-table-column label="icon" align="center" prop="icon" width="140"></el-table-column>
                <el-table-column label="开启" align="center" width="60" v-if="isAdmin">
                    <template slot-scope="scope">
                        <el-switch @change="doDebug(scope.row)" :width="35" v-model="scope.row.show">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" v-if="isAdmin" width="120">
                    <template slot-scope="scope">
                        <el-button class="super-mini-button" type="primary" size="mini" @click.stop="addOrEdit(scope.row)">编辑</el-button>
                        <el-button class="super-mini-button" type="danger" size="mini" @click.stop="removeModel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </paged-table>

        <dialog-edit-menu ref="edit" @fetch-data="fetchData"></dialog-edit-menu>
    </div>
</template>

<script>
import PagedTable from "../components/PagedTable.vue";
import { HttpClient } from "../util/http";
import DialogEditMenu from "../components/dialog/dialogEditMenu.vue";
import { actionConfirm, msgSuccess } from "../util/toast";
import { loginState } from "../util/login.js";

export default {
    components: {
        DialogEditMenu,
        PagedTable,
    },
    mixins: [],
    data() {
        return {
            data: [],
            keyword: "",
            loading: false,
        };
    },
    created() {},
    computed: {
        table() {
            return this.$refs.table;
        },
        edit() {
            return this.$refs.edit;
        },
        isAdmin() {
            if (loginState && loginState.admin) {
                return loginState.admin.masterAdmin;
            } else {
                return false;
            }
        },
    },
    mounted() {},
    methods: {
        async doDebug(value) {
            this.loading = true;
            await HttpClient.post("/menu/put", {
                _id: value._id,
                show: value.show,
            });
            msgSuccess();
            this.refetchData();
        },
        refetchData() {
            this.table.refetchData();
        },
        async fetchData() {
            this.loading = true;
            this.data = await HttpClient.post("/menu/getAll");
            this.loading = false;
        },

        addOrEdit(item) {
            this.edit.addOrEdit(item);
        },
        async removeModel(item) {
            await actionConfirm();
            this.loading = true;
            await HttpClient.post("/menu/remove", {
                _id: item._id,
            });
            msgSuccess();
            this.refetchData();
        },
    },
};
</script>
